import { render } from "./contacto.vue?vue&type=template&id=528fdd3d"
import script from "./contacto.vue?vue&type=script&lang=js"
export * from "./contacto.vue?vue&type=script&lang=js"
script.render = render

export default script